import PropTypes from 'prop-types';

export default {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  selectedRoute: PropTypes.object,
  selectedTrip: PropTypes.object,
  toggleRoutes: PropTypes.func,
  openEditPassenger: PropTypes.func,
  closeEditPassenger: PropTypes.func,
  editOpened: PropTypes.bool,
  selectedPassenger: PropTypes.string,
  classes: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/containers/seats/desktop/SeatsDesktopProps.js